import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-single_page",
  "use": "icon-single_page-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-single_page\"><path d=\"M383 128.1V0L127 256.3h256V128.1zM863 0H447V288.3c0 17.7-14.3 32-32 32H127V993c0 14.9 10.2 27.5 24 31h720c13.8-3.5 24-16.1 24-31V32c0-17.7-14.3-32-32-32z\" fill=\"#CCCCCC\" p-id=\"7907\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol